import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appNavigHost]'
})
export class NavDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
